import { Action, createReducer, on } from '@ngrx/store';

import {
  loadCountriesSuccessAction,
  loadLanguagesSuccessAction,
  setCountryCode,
  toggleEditBarVisibility
} from './actions';
import { SiteContextState, MeasurementSystemsState } from './site-context-state.type';

import { MeasurementSystemsActions } from './actions/measurement-systems.action';
import { MeasurementSystem } from '../types/measurement-system.type';

const initialMeasurementSystemsState: MeasurementSystemsState = {
  entities: null,
  activeMeasurementSystem: null
};

const initialState: SiteContextState = {
  countries: [],
  languages: [],
  measurementSystems: initialMeasurementSystemsState,
  editBarVisibility: false
};

const reducer = createReducer(
  initialState,
  on(
    loadCountriesSuccessAction,
    (state, { payload }): SiteContextState => ({ ...state, countries: payload.countries })
  ),
  on(loadLanguagesSuccessAction, (state, { payload }): SiteContextState => ({ ...state, languages: payload })),
  on(
    setCountryCode,
    (state, { activeCountryCode }): SiteContextState => ({
      ...state,
      activeCountryCode
    })
  ),
  on(
    toggleEditBarVisibility,
    (state): SiteContextState => ({
      ...state,
      editBarVisibility: !state.editBarVisibility
    })
  ),
  on(MeasurementSystemsActions.loadMeasurementSystemSuccess, (state, { payload }): SiteContextState => {
    const entities = payload.reduce(
      (currEntities: { [name: string]: MeasurementSystem }, unitOfMeasurement: MeasurementSystem) => ({
        ...currEntities,
        [unitOfMeasurement.name ?? '']: unitOfMeasurement
      }),
      {
        ...state.measurementSystems.entities
      }
    );
    return { ...state, measurementSystems: { ...state.measurementSystems, entities } };
  }),
  on(MeasurementSystemsActions.setActiveMeasurementSystem, (state, { payload }) => ({
    ...state,
    measurementSystems: {
      ...state.measurementSystems,
      activeMeasurementSystem: payload
    }
  }))
);
export const siteContextReducers = (state: SiteContextState, action: Action): SiteContextState =>
  reducer(state, action);
